import { translation } from "./FPEUtils";

export const makeErrorMessage = errorHandle => {
  let message = errorHandle.message;
  if (errorHandle.replacement) {
    Object.keys(errorHandle.replacement).forEach(key => {
      message = message.replace(`$${key}$`, errorHandle.replacement[key]);
    })
  }
  let errorMessage = translation('failed_to_communication_with_message', {message});
  if (errorHandle.additionalMessage) {
    errorMessage += `\n${translation(errorHandle.additionalMessage)}`;
  }
  return errorMessage;
}
